<template>
  <main class="main report-page">
    <section class="report-header">
      <h1>NERACA</h1>
    </section>

    <v-card class="filter-card no-print" outlined>
      <v-row dense align="center">
        <v-col cols="12" sm="6" md="3">
          <v-select
            v-model="selectedFilterType"
            :items="filterTypeItems"
            item-text="text"
            item-value="value"
            label="Tipe Filter"
            hide-details="auto"
            @blur="getCutOff"
          ></v-select>
        </v-col>
        <v-col cols="12" sm="6" md="3" v-if="selectedFilterType == 'period'">
          <v-select
            v-model="selectedPeriodeType"
            :items="periodeTypeItems"
            item-text="text"
            item-value="value"
            label="Tipe Periode"
            hide-details="auto"
            @blur="getCutOff"
          ></v-select>
        </v-col>
        <v-col cols="4" sm="2" md="1" v-if="selectedFilterType == 'period' && selectedPeriodeType == 'daily'">
          <v-select
            v-model="selectedPeriode.day"
            :items="listPeriode.day"
            label="Hari"
            hide-details="auto"
            @blur="getCutOff"
          >
          </v-select>
        </v-col>
        <v-col
          cols="8"
          sm="3"
          md="2"
          v-if="selectedFilterType == 'period' && ['daily', 'monthly'].includes(selectedPeriodeType)"
        >
          <v-select
            v-model="selectedPeriode.month"
            :items="listPeriode.month"
            label="Bulan"
            hide-details="auto"
            @blur="getCutOff"
          >
          </v-select>
        </v-col>
        <v-col
          cols="6"
          sm="3"
          md="2"
          v-if="selectedFilterType == 'period' && selectedPeriodeType == 'quarterly'"
        >
          <v-select
            v-model="selectedPeriode.quarter"
            :items="listPeriode.quarter"
            label="Quarter"
            hide-details="auto"
            @blur="getCutOff"
          ></v-select>
        </v-col>
        <v-col
          cols="6"
          sm="3"
          md="2"
          v-if="selectedFilterType == 'period' && selectedPeriodeType == 'semester'"
        >
          <v-select
            v-model="selectedPeriode.semester"
            :items="listPeriode.semester"
            label="Semester"
            hide-details="auto"
            @blur="getCutOff"
          ></v-select>
        </v-col>
        <v-col
          cols="6"
          sm="3"
          md="2"
          v-if="
            selectedFilterType == 'period' &&
              ['daily', 'monthly', 'quarterly', 'semester', 'yearly'].includes(selectedPeriodeType)
          "
        >
          <v-select
            v-model="selectedPeriode.year"
            :items="listPeriode.year"
            label="Tahun"
            hide-details="auto"
            @blur="getCutOff"
          >
          </v-select>
        </v-col>
        <v-col cols="12" sm="6" md="3" v-if="selectedFilterType == 'range'">
          <v-menu
            ref="startDateMenu"
            v-model="startDateMenu"
            :close-on-content-click="false"
            :return-value.sync="selectedDateRange.startDate"
            transition="scale-transition"
            offset-y
            min-width="290px"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-text-field
                readonly
                clearable
                label="Tanggal Awal"
                placeholder="Masukkan Tanggal Awal"
                v-bind="attrs"
                v-on="on"
                :value="startDateFormatted"
                hide-details="auto"
                @click:clear="selectedDateRange.startDate = ''"
              ></v-text-field>
            </template>
            <v-date-picker
              v-model="selectedDateRange.startDate"
              locale="id-ID"
              no-title
              scrollable
              @click:date="
                $refs.startDateMenu.save(selectedDateRange.startDate)
                startDateMenu = false
                getCutOff()
              "
            >
              <v-spacer></v-spacer>
              <v-btn text color="primary" @click="startDateMenu = false">Cancel</v-btn>
              <v-btn
                text
                color="primary"
                @click="$refs.startDateMenu.save(selectedDateRange.startDate), getCutOff()"
                >OK</v-btn
              >
            </v-date-picker>
          </v-menu>
        </v-col>
        <v-col cols="12" sm="6" md="3" v-if="selectedFilterType == 'range'">
          <v-menu
            ref="endDateMenu"
            v-model="endDateMenu"
            :close-on-content-click="false"
            :return-value.sync="selectedDateRange.endDate"
            transition="scale-transition"
            offset-y
            min-width="290px"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-text-field
                readonly
                clearable
                label="Tanggal Akhir"
                placeholder="Masukkan Tanggal Akhir"
                v-bind="attrs"
                v-on="on"
                :value="endDateFormatted"
                hide-details="auto"
                @click:clear="selectedDateRange.endDate = ''"
              ></v-text-field>
            </template>
            <v-date-picker
              v-model="selectedDateRange.endDate"
              locale="id-ID"
              no-title
              scrollable
              @click:date="
                $refs.endDateMenu.save(selectedDateRange.endDate)
                endDateMenu = false
                getCutOff()
              "
            >
              <v-spacer></v-spacer>
              <v-btn text color="primary" @click="endDateMenu = false">Cancel</v-btn>
              <v-btn
                text
                color="primary"
                @click="$refs.endDateMenu.save(selectedDateRange.endDate), getCutOff()"
                >OK</v-btn
              >
            </v-date-picker>
          </v-menu>
        </v-col>
        <v-spacer></v-spacer>
        <v-col cols="12" sm="6" md="auto" class="d-flex align-end">
          <v-btn color="primary" @click="printReport"> <v-icon left>mdi-printer</v-icon> Cetak </v-btn>
        </v-col>
      </v-row>
    </v-card>

    <v-progress-linear :active="isLoading" indeterminate rounded height="6" class="mb-4"></v-progress-linear>

    <v-row v-if="listDebit.length > 0 && listCredit.length > 0" class="report-grid">
      <v-col cols="12" md="6">
        <v-card id="debit" class="report-table-card" outlined>
          <div class="total-row">
            <span>JUMLAH</span>
            <strong>{{ getCurrency(totalDebit) }}</strong>
          </div>
          <div class="table-scroll">
            <v-simple-table dense class="report-table">
              <template v-slot:default>
                <thead>
                  <tr>
                    <th class="text-left">Kode</th>
                    <th class="text-left">Pos</th>
                    <th class="text-left"></th>
                    <th class="text-left"></th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="item in listDebit" :key="item._id">
                    <td v-if="!item.isNameBold">{{ item.code }}</td>
                    <td v-if="item.isNameBold">
                      <h3>
                        <b>{{ item.code }}</b>
                      </h3>
                    </td>
                    <td v-if="!item.isNameBold" class="pl-10">{{ item.name }}</td>
                    <td v-if="item.isNameBold && item.isCenter" class="d-flex justify-center">
                      <h2>
                        <b>{{ item.name }}</b>
                      </h2>
                    </td>
                    <td v-if="item.isNameBold && !item.isCenter">
                      <h3>
                        <b>{{ item.name }}</b>
                      </h3>
                    </td>
                    <td v-if="!item.isNominalBold">
                      {{ item.isCenter ? '' : getCurrency(item.nominal) }}
                    </td>
                    <td v-if="item.isNominalBold">
                      <b>{{ getCurrency(item.nominal) }}</b>
                    </td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>
          </div>
        </v-card>
      </v-col>

      <v-col cols="12" md="6">
        <v-card id="credit" class="report-table-card" outlined>
          <div class="total-row">
            <span>JUMLAH</span>
            <strong>{{ getCurrency(totalCredit) }}</strong>
          </div>
          <div class="table-scroll">
            <v-simple-table dense class="report-table">
              <template v-slot:default>
                <thead>
                  <tr>
                    <th class="text-left">Kode</th>
                    <th class="text-left">Pos</th>
                    <th class="text-left"></th>
                    <th class="text-left"></th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="item in listCredit" :key="item._id">
                    <td v-if="!item.isNameBold">{{ item.code }}</td>
                    <td v-if="item.isNameBold">
                      <h3>
                        <b>{{ item.code }}</b>
                      </h3>
                    </td>
                    <td v-if="!item.isNameBold" class="pl-10">{{ item.name }}</td>
                    <td v-if="item.isNameBold && !item.isCenter">
                      <h3>
                        <b>{{ item.name }}</b>
                      </h3>
                    </td>
                    <td v-if="item.isNameBold && item.isCenter" class="d-flex justify-center">
                      <h2>
                        <b>{{ item.name }}</b>
                      </h2>
                    </td>
                    <td v-if="!item.isNominalBold">
                      {{ item.isCenter ? '' : getCurrency(item.nominal) }}
                    </td>
                    <td v-if="item.isNominalBold">
                      <b>{{ getCurrency(item.nominal) }}</b>
                    </td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>
          </div>
        </v-card>
      </v-col>
    </v-row>
  </main>
</template>
<script>
import Constant from '@/const'
import ConstantMixin from '@/constantMixin'

const _ = require('lodash')
const moment = require('moment')
const axios = require('axios')

export default {
  name: 'BalanceSheet',
  components: {},
  mixins: [ConstantMixin],
  data() {
    return {
      menuCode: 'b-01',
      access: {
        write: false,
        update: false,
        delete: false
      },
      isLoading: true,
      listDebit: [],
      listCredit: [],
      selectedFilterType: 'period',
      filterTypeItems: [
        { text: 'Periode', value: 'period' },
        { text: 'Range Tanggal', value: 'range' }
      ],
      selectedPeriodeType: 'daily',
      periodeTypeItems: [
        { text: 'Harian', value: 'daily' },
        { text: 'Bulanan', value: 'monthly' },
        { text: 'Quarter', value: 'quarterly' },
        { text: 'Semester', value: 'semester' },
        { text: 'Tahunan', value: 'yearly' }
      ],
      startDateMenu: false,
      endDateMenu: false,
      isCurrentDate: true,
      totalDebit: 0,
      totalCredit: 0,
      selectedPeriode: {
        day: '',
        year: '',
        month: '',
        quarter: '1',
        semester: '1'
      },
      selectedDateRange: {
        startDate: '',
        endDate: ''
      },
      listPeriode: {
        day: [],
        year: [],
        month: [],
        quarter: [
          { text: 'Q1', value: '1' },
          { text: 'Q2', value: '2' },
          { text: 'Q3', value: '3' },
          { text: 'Q4', value: '4' }
        ],
        semester: [
          { text: 'Semester 1', value: '1' },
          { text: 'Semester 2', value: '2' }
        ]
      }
    }
  },
  computed: {
    startDateFormatted() {
      return this.selectedDateRange.startDate
        ? moment(this.selectedDateRange.startDate)
            .locale('id')
            .format('D MMMM YYYY')
        : ''
    },
    endDateFormatted() {
      return this.selectedDateRange.endDate
        ? moment(this.selectedDateRange.endDate)
            .locale('id')
            .format('D MMMM YYYY')
        : ''
    }
  },
  mounted() {
    this.$nextTick(() => {
      let i = 0
      while (i < 10) {
        this.listPeriode.year.push(
          moment()
            .add(i * -1, 'year')
            .format('YYYY')
        )
        i++
      }
      i = 0
      let month = moment()
        .startOf('year')
        .format()
      while (i < 12) {
        this.listPeriode.month.push({
          text: moment(month)
            .locale('id')
            .format('MMMM'),
          value: moment(month)
            .locale('id')
            .format('M')
        })
        month = moment(month)
          .add(1, 'month')
          .format()
        i++
      }

      i = 1
      while (i < 32) {
        this.listPeriode.day.push(i.toString())
        i++
      }

      this.selectedPeriode.year = moment().format('YYYY')
      this.selectedPeriode.month = moment().format('M')
      this.selectedPeriode.day = moment().format('D')
      this.selectedDateRange.startDate = moment()
        .startOf('month')
        .format('YYYY-MM-DD')
      this.selectedDateRange.endDate = moment().format('YYYY-MM-DD')

      this.isCurrentDate =
        moment()
          .locale('id')
          .format('D-M-YYYY') ==
        `${this.selectedPeriode.day}-${this.selectedPeriode.month}-${this.selectedPeriode.year}`

      this.getCutOff()
    })
  },
  methods: {
    printReport() {
      window.print()
    },
    getCutOff() {
      try {
        this.isLoading = true

        if (
          this.selectedFilterType == 'range' &&
          (!this.selectedDateRange.startDate || !this.selectedDateRange.endDate)
        ) {
          this.totalDebit = 0
          this.totalCredit = 0
          this.listDebit = []
          this.listCredit = []
          this.isLoading = false
          return
        }

        const cutoffDate = moment(
          `${this.selectedPeriode.year}-${this.selectedPeriode.month}-${this.selectedPeriode.day}`
        ).format('YYYY-M-D')
        let periodStartDate = ''
        let periodEndDate = ''

        if (this.selectedPeriodeType == 'monthly') {
          periodStartDate = moment(`${this.selectedPeriode.year}-${this.selectedPeriode.month}-01`).format(
            'YYYY-MM-DD'
          )
          periodEndDate = moment(periodStartDate)
            .endOf('month')
            .format('YYYY-MM-DD')
        } else if (this.selectedPeriodeType == 'quarterly') {
          const startMonth = (Number(this.selectedPeriode.quarter) - 1) * 3 + 1
          periodStartDate = moment(`${this.selectedPeriode.year}-${startMonth}-01`).format('YYYY-MM-DD')
          periodEndDate = moment(periodStartDate)
            .add(2, 'month')
            .endOf('month')
            .format('YYYY-MM-DD')
        } else if (this.selectedPeriodeType == 'semester') {
          const startMonth = this.selectedPeriode.semester == '1' ? 1 : 7
          periodStartDate = moment(`${this.selectedPeriode.year}-${startMonth}-01`).format('YYYY-MM-DD')
          periodEndDate = moment(periodStartDate)
            .add(5, 'month')
            .endOf('month')
            .format('YYYY-MM-DD')
        } else if (this.selectedPeriodeType == 'yearly') {
          periodStartDate = moment(`${this.selectedPeriode.year}-01-01`).format('YYYY-MM-DD')
          periodEndDate = moment(periodStartDate)
            .endOf('year')
            .format('YYYY-MM-DD')
        }

        this.isCurrentDate =
          this.selectedFilterType == 'period' &&
          this.selectedPeriodeType == 'daily' &&
          moment()
            .locale('id')
            .format('D-M-YYYY') ==
            `${this.selectedPeriode.day}-${this.selectedPeriode.month}-${this.selectedPeriode.year}`
        const endpoint =
          this.selectedFilterType == 'range'
            ? Constant.apiUrl.concat(
                '/accounting/chartaccount/cutoff?startDate=',
                moment(this.selectedDateRange.startDate).format('YYYY-MM-DD'),
                '&endDate=',
                moment(this.selectedDateRange.endDate).format('YYYY-MM-DD')
              )
            : this.selectedPeriodeType == 'daily'
            ? Constant.apiUrl.concat('/accounting/chartaccount/cutoff?date=', cutoffDate)
            : Constant.apiUrl.concat(
                '/accounting/chartaccount/cutoff?startDate=',
                periodStartDate,
                '&endDate=',
                periodEndDate
              )

        this.runApiCalls(() => {
          axios
            .get(endpoint)
            .then(response => {
              this.totalDebit = 0
              this.totalCredit = 0
              this.listDebit = []
              this.listCredit = []

              this.isLoading = false
              if (response.status == 200) {
                let { data } = response.data

                //! Split code to easy grouping and get nominal by filter
                data.item = data.item.map(m => {
                  return {
                    ...m,
                    splitCode: m.id_account.code.split('.'),
                    nominal: this.isCurrentDate ? m.id_account.nominal : m.nominal
                  }
                })

                //* Get SubGorup for Debit
                let debitGroup = data.item.filter(
                  v => v.splitCode[0] == '1' && v.splitCode[1] != '0' && v.splitCode[2] == '0'
                )

                //? Sum For Total Debit
                this.totalDebit = _.sumBy(debitGroup, 'nominal')

                //* Grouping Debit Account
                for (let i = 0; i < debitGroup.length; i++) {
                  const itemGroup = debitGroup[i]
                  if (i == 0)
                    this.listDebit.push({
                      code: '',
                      name: data.item
                        .find(
                          v =>
                            v.splitCode[0] == itemGroup.splitCode[0] &&
                            v.splitCode[1] == '0' &&
                            v.splitCode[2] == '0'
                        )
                        .id_account.name.toUpperCase(),
                      nominal: '',
                      isNameBold: true,
                      isCenter: true
                    })

                  this.listDebit.push({
                    code: itemGroup.id_account.code,
                    name: itemGroup.id_account.name,
                    nominal: '',
                    isNameBold: true
                  })

                  for (let j = 0; j < data.item.length; j++) {
                    const item = data.item[j]
                    const splitCode = item.id_account.code.split('.')
                    if (item.id_account.code == itemGroup.id_account.code) continue
                    if (splitCode[0] == itemGroup.splitCode[0] && splitCode[1] == itemGroup.splitCode[1]) {
                      this.listDebit.push({
                        code: item.id_account.code,
                        name: item.id_account.name,
                        nominal: item.nominal,

                        isTab: true
                      })
                    }
                  }
                  this.listDebit.push({
                    code: '',
                    name: `Jumlah ${itemGroup.id_account.name}`,
                    nominal: itemGroup.nominal,
                    isNominalBold: true
                  })
                  this.listDebit.push({
                    code: '',
                    name: '',
                    nominal: '',
                    isCenter: true
                  })
                }

                //! Get Grouping for Credit
                let creditGroup = data.item.filter(
                  v => ['2'].includes(v.splitCode[0]) && v.splitCode[1] != '0' && v.splitCode[2] == '0'
                )

                //? Sum For Total Credit
                this.totalCredit = _.sumBy(creditGroup, 'nominal') + data.lossProfit

                //* Grouping Credit
                for (let i = 0; i < creditGroup.length; i++) {
                  const itemGroup = creditGroup[i]
                  if (i == 0)
                    this.listCredit.push({
                      code: '',
                      name: data.item
                        .find(
                          v =>
                            v.splitCode[0] == itemGroup.splitCode[0] &&
                            v.splitCode[1] == '0' &&
                            v.splitCode[2] == '0'
                        )
                        .id_account.name.toUpperCase(),
                      nominal: '',
                      isNameBold: true,
                      isCenter: true
                    })
                  else {
                    if (creditGroup[i].splitCode[0] != creditGroup[i - 1].splitCode[0])
                      this.listCredit.push({
                        code: '',
                        name: data.item
                          .find(
                            v =>
                              v.splitCode[0] == itemGroup.splitCode[0] &&
                              v.splitCode[1] == '0' &&
                              v.splitCode[2] == '0'
                          )
                          .id_account.name.toUpperCase(),
                        nominal: '',
                        isNameBold: true,
                        isCenter: true
                      })
                  }

                  this.listCredit.push({
                    code: itemGroup.id_account.code,
                    name: itemGroup.id_account.name,
                    nominal: '',
                    isNameBold: true
                  })

                  for (let j = 0; j < data.item.length; j++) {
                    const item = data.item[j]
                    const splitCode = item.id_account.code.split('.')
                    if (item.id_account.code == itemGroup.id_account.code) continue
                    if (splitCode[0] == itemGroup.splitCode[0] && splitCode[1] == itemGroup.splitCode[1]) {
                      this.listCredit.push({
                        code: item.id_account.code,
                        name: item.id_account.name,
                        nominal: item.nominal,
                        isTab: true
                      })
                    }
                  }
                  this.listCredit.push({
                    code: '',
                    name: `Jumlah ${itemGroup.id_account.name}`,
                    nominal: itemGroup.nominal,

                    isNominalBold: true
                  })
                  if (creditGroup.length - 1 == i) {
                    this.listCredit.push({
                      code: '',
                      name: `Laba ditahan Berjalan`,
                      nominal: data.lossProfit,

                      isNominalBold: true
                    })
                  }
                  this.listCredit.push({
                    code: '',
                    name: '',
                    nominal: '',
                    isCenter: true
                  })
                }
              }
            })

            .catch(error => {
              this.totalDebit = 0
              this.totalCredit = 0
              this.listDebit = []
              this.listCredit = []
              this.isLoading = false

              // console.log(error)
            })
        })
      } catch (error) {
        this.isLoading = false
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.report-page {
  padding: 20px;
}
.report-header {
  margin-bottom: 16px;
  text-align: center;
}
.report-header h1 {
  margin: 0;
  letter-spacing: 1px;
}
.filter-card {
  margin-bottom: 16px;
  padding: 16px;
}
.report-grid {
  row-gap: 16px;
}
.report-table-card {
  height: 100%;
  padding: 8px 12px;
}
.table-scroll {
  overflow-x: auto;
}
.report-table {
  min-width: 720px;
}
.total-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-weight: 700;
  margin-bottom: 14px;
}
.total-row strong {
  font-size: 1.2rem;
}

@media (max-width: 960px) {
  .report-page {
    padding: 12px;
  }
  .filter-card {
    padding: 12px;
  }
}

@media print {
  .report-page {
    padding: 0;
  }
  .no-print {
    display: none !important;
  }
  .filter-card {
    display: none;
  }
  .report-table {
    min-width: auto;
  }
}
</style>
